import React from "react";
import { Section, ContentBlock } from "./ui";
import "./BrandStoryHighlight.css";

const BrandStoryHighlight = ({
  mainText = "",
  subText = "",
  backgroundColor = "var(--color-primary)",
  textColor = "var(--color-secondary)", // Blue color from the image
  subTextColor = "var(--color-secondary-dark)",
  className = "",
  spacing = "spacious",
  svgStrokeColor = "rgb(255, 255, 255)",
  svgOpacity = 0.5,
  showSvgBackground = true,
  ...props
}) => {
  // Create SVG background URLs with different stroke widths for responsive design
  const createSvgUrl = (strokeWidth) =>
    `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1504 839' fill='none'%3E%3Cpath d='M0 1.5293L361.772 173.363C422.412 201.919 453.727 243.691 446.257 286.11L437.468 336.127C433.98 355.966 443.282 375.856 463.915 392.634L493.693 416.858C506.483 427.259 515.253 438.852 519.529 451L540.498 510.567C550.253 538.302 584.012 562.145 631.999 575.196L917.243 652.774C949.701 661.605 985.687 666.339 1022.28 666.606L1211.89 667.981C1256.7 670.158 1297.95 681.649 1326.31 699.855L1433.73 768.807C1465.91 789.467 1489.56 813.207 1503.54 838.529' stroke='${encodeURIComponent(
      svgStrokeColor
    )}' stroke-width='${strokeWidth}' fill='none'/%3E%3C/svg%3E")`;

  const svgBackgroundUrlDesktop = showSvgBackground
    ? createSvgUrl("2")
    : "none";
  const svgBackgroundUrlMobile = showSvgBackground ? createSvgUrl("1") : "none";

  return (
    <Section
      margin={false}
      variant="custom"
      spacing={spacing}
      className={`brand-story-highlight ${className}`}
      style={{
        backgroundColor: backgroundColor,
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "--svg-background-desktop": svgBackgroundUrlDesktop,
        "--svg-background-mobile": svgBackgroundUrlMobile,
        "--svg-opacity": svgOpacity,
      }}
      {...props}
    >
      <ContentBlock maxWidth="6xl" spacing="none" className="text-center">
        <div
          className="brand-story-content"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1 },
          }}
        >
          {/* Main Text */}
          <h1
            className="brand-story-main-text"
            style={{
              fontSize: "clamp(3rem, 12vw, 7rem)",
              fontWeight: "900",
              letterSpacing: "0.01em",
              lineHeight: "0.9",
              color: textColor,
              textTransform: "uppercase",
              marginBottom: "0.2em",
              fontFamily: "var(--font-family-heading)",
              margin: "0",
              padding: "0",
              willChange: "transform, opacity",
            }}
            variants={{
              hidden: {
                opacity: 0,
                y: 100,
                scale: 0.8,
              },
              visible: {
                opacity: 1,
                y: 0,
                scale: 1,
                transition: {
                  duration: 0.8,
                  ease: "easeOut",
                  delay: 0.2,
                },
              },
            }}
          >
            {mainText}
          </h1>

          {/* Sub Text */}
          <h2
            className="brand-story-sub-text"
            style={{
              fontSize: "clamp(2rem, 8vw, 5rem)",
              fontWeight: "300",
              fontStyle: "italic",
              letterSpacing: "0.01em",
              lineHeight: "1.1",
              color: subTextColor,
              marginTop: "0",
              fontFamily: "var(--font-family-heading)",
              margin: "0",
              padding: "0",
              willChange: "transform, opacity",
            }}
            variants={{
              hidden: {
                opacity: 0,
                y: 80,
                scale: 0.9,
              },
              visible: {
                opacity: 1,
                y: 0,
                scale: 1,
                transition: {
                  duration: 0.6,
                  ease: "easeOut",
                  delay: 0.6,
                },
              },
            }}
          >
            {subText}
          </h2>
        </div>
      </ContentBlock>
    </Section>
  );
};

export default BrandStoryHighlight;
